import { getSuppliers } from '../../../api'
import { getItemsFromApiResponse } from '../../../utils/api'
import { UserSelect } from '../../User'

import { toSupplierSelectItems } from './SupplierSelect.utils'

function SupplierSelect({
  toPreparedItems = toSupplierSelectItems,
  ...restProps
}) {
  return (
    <UserSelect
      {...restProps}
      getData={getSuppliers}
      getDataItems={getItemsFromApiResponse}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default SupplierSelect
